module.exports = __webpack_public_path__ + "media/product-reveal.d33fd753.mp3";